import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { NgxPersianModule } from 'ngx-persian';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { LoadingInterceptor } from './_interceptors/loading.interceptor';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MapService } from './services/map.service';
import { OtherService } from './services/other.service';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { NgPersianDatepickerModule } from 'ng-persian-datepicker';
import { AudioRecordingService } from './services/audio-recording.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { GurdServiceService } from './services/gurd-service.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MapDialog } from './components/mapDialog/mapDialog.Component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { BusinessDetailComponent } from './components/business-detail/business-detail.component';
import { NewComponent } from './components/new/new.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { HomeComponent } from './components/home/home.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { GuidePagesComponent } from './components/guide-pages/guide-pages.component';
import { NewsComponent } from './components/news/news.component';
import { ScrollToEndDirective } from './scroll-to-end.directive';
import { AdsInfiniteScrollDirective } from './components/business-main-infinite-scroll/directive/ads-infinite-scroll.directive';
import { FooterComponent } from './components/footer/footer.component';
import { CustomFilterComponent } from './components/custom-filter/custom-filter.component';
import { NewTripComponent } from './components/trip/new-trip/new-trip.component';
import { AllTripComponent } from './components/trip/all-trip/all-trip.component';
import { CustomMapComponent } from './custom-map/custom-map.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { StarRatingModule } from 'angular-star-rating';
import { ProfileComponent } from './components/profile/profile.component';
import { SupportComponent } from './components/support/support.component';
import { PaymentComponent } from './components/payment/payment.component';
import { MarketersLandingComponent } from './components/marketers/marketers-landing/marketers-landing.component';
import { NewTripMarketersComponent } from './components/marketers/new-trip-marketers/new-trip-marketers.component';
import { HomeMarketersComponent } from './components/marketers/home-marketers/home-marketers.component';
import { PartnerDashboardComponent } from './components/_Partners/partner-dashboard/partner-dashboard.component';
import { PartnerTripsComponent } from './components/_Partners/partner-trips/partner-trips.component';
import { PartnerFinancialComponent } from './components/_Partners/partner-financial/partner-financial.component';
import { DriverAdsComponent } from './components/driver-ads/driver-ads.component';
import { TaxilonAdsDetailComponent } from './components/taxilon-ads-detail/taxilon-ads-detail.component';
import { InfiniteScrollDirective } from './components/driver-ads/directive/infinite-scroll.directive';
import { CustomGalleryComponent } from './custom-gallery/custom-gallery.component';
import { TruckValidateComponent } from './components/truck-validate/truck-validate.component';
import { NewTripPartnerComponent } from './components/trip/new-trip-partner/new-trip-partner.component';
import { EducationComponent } from './education/education.component';
import { RouteComponent } from './components/route/route.component';
import { FullPaymentComponent } from './full-payment/full-payment.component';
import { BusinessComponent } from './components/business/business.component';
import { BusinessPageComponent } from './components/business-page/business-page.component';
import { TaxiPlateComponent } from './components/taxi-plate/taxi-plate.component';


@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    MapDialog,
    BusinessDetailComponent,
    NewComponent,
    HomeComponent,
    GuidePagesComponent,
    NewsComponent,
    ScrollToEndDirective,
    AdsInfiniteScrollDirective,
    FooterComponent,
    CustomFilterComponent,
    NewTripComponent,
    AllTripComponent,
    CustomMapComponent,
    ProfileComponent,
    SupportComponent,
    PaymentComponent,
    MarketersLandingComponent,
    NewTripMarketersComponent,
    HomeMarketersComponent,
    PartnerDashboardComponent,
    PartnerTripsComponent,
    PartnerFinancialComponent,
    DriverAdsComponent,
    TaxilonAdsDetailComponent,
    InfiniteScrollDirective,
    CustomGalleryComponent,
    TruckValidateComponent,
    NewTripPartnerComponent,
    EducationComponent,
    RouteComponent,
    FullPaymentComponent,
    BusinessComponent,
    BusinessPageComponent,
    TaxiPlateComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CarouselModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatExpansionModule,
    NgxStarRatingModule,
    AngularSignaturePadModule,
    StarRatingModule.forRoot(),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),

    NgxPersianModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      easing: 'slide-in',
      timeOut: 3000,
      preventDuplicates: true
    }),
    NgPersianDatepickerModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    NgxMaterialTimepickerModule,
    MatIconModule,
    MatAutocompleteModule,
    MatDividerModule,
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    MatRadioModule,
    MatListModule,
    MatBottomSheetModule,
    MatCheckboxModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    MatSnackBarModule,
    NgbModule,

  ],
  schemas: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }, MapService, DatePipe, OtherService, AudioRecordingService, GurdServiceService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }